import { NavLink } from '@models/navlink.model';

export const MenuPartner: NavLink[] = [
  {
    title: 'Parceiros',
    path: 'parceiro',
    params: 'partners',
    children: [
      {
        title: 'Parceiros de vale-pedágio',
        path: 'vale-pedagio',
        params: 'toll-voucher-partners',
        children: [],
      },
      {
        title: 'Minha conta',
        path: 'minha-conta',
        params: 'my-account',
        children: [],
      },
    ],
  },
];
